export default {
  title: {
    en: 'Ship my perfume once every {period, plural, one {month}, other {# months}}',
  },
  nextShipping: {
    en: 'Next shipment, {date}',
  },
  nextBilling: {
    en: 'Next bill, {date}',
  },
}
